// 헤더 언어
export const langs = [
  {
    ko: "한국어",
    en: "KOR",
    value: "ko",
    code: "ko",
  },
  {
    ko: "영문",
    en: "EN",
    value: "en",
    code: "en",
  },
  // {
  //   ko: "일본어",
  //   en: "Ja",
  //   value: "ja",
  //   code: "ja",
  // },
];

//페이지 selecter
export const pageSizeSelect = [10, 20, 40, 100];

// 회원상태
export const manYns = [
  { ko: "신청", value: "R", en: "Requested", code: "R" },
  { ko: "승인", value: "D", en: "Approved", code: "D" },
  { ko: "탈퇴", value: "S", en: "Withdrawn", code: "S" },
];

//관리자 권한
export const authOptions = [
  {
    ko: "소유자",
    us: "Owner",
    value: "OTAOWENER01",
    code: "OTAOWENER01",
  },
  {
    ko: "관리자",
    us: "Manager",
    value: "OTAMAN01",
    code: "OTAMAN01",
  },
  {
    ko: "개발자",
    us: "Developer",
    value: "OTADEV01",
    code: "OTADEV01",
  },
  {
    ko: "리포터",
    us: "Reporter",
    value: "OTATRP01",
    code: "OTATRP01",
  },
  {
    ko: "시스템관리자",
    us: "System administrator",
    value: "SYSADMIN",
    code: "SYSADMIN",
  },
];

// 달력
export const days = [
  {
    ko: "일",
    value: "0",
    en: "SUN",
  },
  {
    ko: "월",
    value: "1",
    en: "MON",
  },
  {
    ko: "화",
    value: "2",
    en: "TUE",
  },
  {
    ko: "수",
    value: "3",
    en: "WED",
  },
  {
    ko: "목",
    value: "4",
    en: "THU",
  },
  {
    ko: "금",
    value: "5",
    en: "FRI",
  },
  {
    ko: "토",
    value: "6",
    en: "SAT",
  },
];

export const mths = [
  {
    ko: "1월",
    en: "1", //January,	Jan
    value: 1,
  },
  {
    ko: "2월",
    en: "2", //February	Feb
    value: 2,
  },
  {
    ko: "3월",
    en: "3", //March	Mar
    value: 3,
  },
  {
    ko: "4월",
    en: "4", //	April, 	Apr
    value: 4,
  },
  {
    ko: "5월",
    en: "5", //May	May
    value: 5,
  },
  {
    ko: "6월",
    en: "6", //June	Jun
    value: 6,
  },
  {
    ko: "7월",
    en: "7", //July	Jul
    value: 7,
  },
  {
    ko: "8월",
    en: "8", //August	Aug
    value: 8,
  },
  {
    ko: "9월",
    en: "9", //September	Sep
    value: 9,
  },
  {
    ko: "10월",
    en: "10", //October	Oct
    value: 10,
  },
  {
    ko: "11월",
    en: "11", //November	Nov
    value: 11,
  },
  {
    ko: "12월",
    en: "12", //December	Dec
    value: 12,
  },
];

//판매 구분
export const sellPriOptions = [
  {
    ko: "판매가",
    en: "sellPrice",
    code: "01",
    value: "sellPri",
  },
  {
    ko: "입금가",
    en: "netRate",
    code: "02",
    value: "netRate",
  },
];

//숙소등급
export const lodRatOptions = [
  {
    ko: "",
    en: "",
    code: "",
    value: "",
  },
];

//객실옵션레이트 체크아웃시간
export const lastTimes = [
  {
    ko: "9:00",
    en: "9:00",
    value: "9:00",
    code: "9:00",
  },
  {
    ko: "10:00",
    en: "10:00",
    value: "10:00",
    code: "10:00",
  },
  {
    ko: "11:00",
    en: "11:00",
    value: "11:00",
    code: "11:00",
  },
  {
    ko: "12:00",
    en: "12:00",
    value: "12:00",
    code: "12:00",
  },
  {
    ko: "13:00",
    en: "13:00",
    value: "13:00",
    code: "13:00",
  },
  {
    ko: "14:00",
    en: "14:00",
    value: "14:00",
    code: "14:00",
  },
  {
    ko: "15:00",
    en: "15:00",
    value: "15:00",
    code: "15:00",
  },
  {
    ko: "16:00",
    en: "16:00",
    value: "16:00",
    code: "16:00",
  },
  {
    ko: "17:00",
    en: "17:00",
    value: "17:00",
    code: "17:00",
  },
  {
    ko: "18:00",
    en: "18:00",
    value: "18:00",
    code: "18:00",
  },
  {
    ko: "19:00",
    en: "19:00",
    value: "19:00",
    code: "19:00",
  },
  {
    ko: "20:00",
    en: "20:00",
    value: "20:00",
    code: "20:00",
  },
];

// 객실예약 조회기준
export const dateTyps = [
  {
    ko: "객실상품일자",
    en: "Room Product Date",
    value: "sell",
    code: "sell",
  },
  {
    ko: "객실상품예약일자",
    en: "Room Product Reservation Date",
    value: "resv",
    code: "resv",
  },
  {
    ko: "객실상품예약취소일자",
    en: "Room Product Reservation Cancel Date",
    value: "rmCnlResv",
    code: "rmCnlResv",
  },
];

// 상품채널
export const lodChls = [
  {
    ko: "UB사이트",
    en: "UB",
    value: "UBS",
    code: "UBS",
  },
];
